import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/time_entries";

export default {
  async getEmployeeEntries(id, params) {
    return await Api()
      .get(`/api/employees/${id}/time_entries`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async getEntries(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  // Segundos imputados a cada ticket (todos los usuarios): { [ticketId]: segundos }
  async getTicketTotals(ticketIds) {
    return await Api()
      .get(`${RESOURCE_TRACKER}/ticket_totals`, { params: { ticketIds } })
      .catch((err) => errorHandler(err, null));
  },
  async getProjectSelector(params) {
    return await Api()
      .get(`${RESOURCE_TRACKER}/project_selector`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async getClientSelector(params) {
    return await Api()
      .get(`${RESOURCE_TRACKER}/client_selector`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createEntry(params) {
    return Api()
      .post(RESOURCE_TRACKER, params);
    // El componente maneja el error para mostrar mensajes de validación 422
  },
  async updateEntry(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params);
    // El componente maneja el error para mostrar mensajes de validación 422
  },
  async bulkUpdateEntries(params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/bulk`, params);
    // El componente maneja el error para mostrar mensajes de validación
  },
  async startEntry(entry) {
    return Api()
      .post(`${RESOURCE_TRACKER}`, entry)
      .catch((err) => errorHandler(err, null));
  },
  async stopEntry(entry) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${entry.id}`, entry)
      .catch((err) => errorHandler(err, null));
  },
  async discardEntry(id) {
    return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
  async splitEntry(id, params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/split`, params)
      .catch((err) => errorHandler(err, null));
  },
  async duplicateEntry(id) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/duplicate`)
      .catch((err) => errorHandler(err, null));
  },
  async getCurrentEntry(id) {
    return (
      Api()
        // .get(`/api/employees/${id}/time_entries`)
        .get(`${RESOURCE_TRACKER}/${id}`)
        .catch((err) => errorHandler(err, null))
      );
    },
    async getReport(params){
      return Api()
      .get(`${RESOURCE_TRACKER}/report`, {params: params,  responseType: 'blob'})
      .catch((err) => errorHandler(err, null))
  },
  async getOwnerReport(params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/owner_report`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async getOwnerReportExport(params, hourlyCostsFile) {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("hourlyCostsFile", hourlyCostsFile);

    return Api()
      .post(`${RESOURCE_TRACKER}/owner_report/export`, formData, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-Type': 'multipart/form-data',
        },
      });
  }
};
